import { render, staticRenderFns } from "./consentForm.vue?vue&type=template&id=b23a311c&scoped=true"
import script from "./consentForm.vue?vue&type=script&lang=js"
export * from "./consentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23a311c",
  null
  
)

export default component.exports